import {ACTION_TYPES} from "../../consts";
import {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";
// import {BETTING_PROMOTION} from "../../../apps/website/modules/betting-promotion.module/bettin-ptomotion.module.consts";
import {AppController} from "../../app/app-controller";
import {BettingPromotionBaseHandler} from "./betting-promotion.base.handler";
import {RouterController} from "../../components/router/router-controller";
import {PopupsDisplayManager} from "../../managers/popups-display.manager";
import {POPUP_DISPLAY} from "../../models/popup/consts";

export class BettingPromotionModulePopulateHandler extends BettingPromotionBaseHandler {
  controller: AppController;
  routerController: RouterController
  type = ACTION_TYPES.bettingPromotionPopulate;
  pageNum: Number;

  static injectables = [...BettingPromotionBaseHandler.injectables, RouterController, PopupsDisplayManager];

  constructor(localStorageUtils: LocalStorageUtils, routerController: RouterController, popupsDisplayManager: PopupsDisplayManager) {
    super(localStorageUtils);

    this.pageNum = 0;
    this.routerController = routerController;
    this.popupsDisplayManager = popupsDisplayManager;
  }

  onInitialized(controller: RouterController) {
    super.onInitialized(controller);
  }

  async onLoaded(): Promise<*> {
    super.onLoaded();

    this.popupsDisplayManager.registerToChange(POPUP_DISPLAY.AUTO_DISPLAY_POPUPS.bp,
        (params) => setTimeout(() => this.controller.action(ACTION_TYPES.bettingPromotionDisplay, { isVisible: this.model.isValidVisibility }), params.delay * 1000)
    );
  }

  action(params) {
    this.model.isValidVisibility = this.isPopupVisible(params.utmId);
  }

  isPopupVisible(utmId: String, force: Boolean = false): Boolean {
    let isPopupVisible = false;
    const {supportedCountriesList} = this.model.remoteConfigModel;

    if (!this.state.settings.isWidget) {
      const isCampaignLink = this.model.isCampaignLink;
      // const isBettingPromotionIgnored: Boolean = this.bettingPromotionClickType === BETTING_PROMOTION.CLICK_TYPE.clear;

      if (isCampaignLink) {
        isPopupVisible = this.isValidUtmId(utmId);
      } else if (supportedCountriesList?.includes(this.state.locale.userCountryId)) {
        if (force) {
          isPopupVisible = true;
        } else {
          isPopupVisible = true;
        }
      }
    }

    return isPopupVisible
  }

  isValidUtmId(utmId) {
    const {blacklistCampaigns} = this.model.remoteConfigModel;
    const isFromBlackList: Boolean = blacklistCampaigns.filter((id: String) => utmId === id).length > 0;
    const isValidUtmId: Boolean = !isFromBlackList && this.updateModelForCampaignUser();

    return isValidUtmId;
  }

  updateModelForCampaignUser(): Boolean {
    this.model.localStorageModel.sessionCounter = 1;
    this.model.localStorageModel.visibleCounter = 1;

    this.updateLocalStorageModel()

    return true;
  }

  // showBettingPromotion(visibleNumber): Boolean {
  //   const {maxDisplays} = this.model.remoteConfigModel;
  //   const isMaxVisible: Boolean = this.popupVisibleCounter >= maxDisplays;
  //   const isVisible = !isMaxVisible && this.model.localStorageModel.sessionCounter % visibleNumber === 0;
  //
  //   return isVisible
  // }

  get popupVisibleCounter(): Number {
    const popupVisibleCounter = this.model.localStorageModel.visibleCounter;

    return popupVisibleCounter;
  }

  get bettingPromotionClickType(): Number {
    return this.model.localStorageModel.clickType;
  }
}
